import { UserGroup } from './user-group';

export class UserInformation {
  public loginName = '';
  public displayName = '';
  public department = '';
  public userID = '';
  public userGroups: UserGroup[] = [];
  constructor(loginName: string, userId: string, displayName: string, department: string) {
    this.loginName = loginName;
    this.userID = userId;
    this.displayName = displayName;
    this.department = department;
  }

  public get isEmpty(): boolean {
    return !this.loginName && !this.displayName && !this.department;
  }
}
